import { FaireHelmet } from "@faire/deprecated-retailer-visitor-shared/components/Helmet/index";
import { useLoggedOutSuppliersPageMetaTagsTitleAndDescription } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/LoggedOutSuppliersPageMetaTags/useLoggedOutSuppliersPageMetaTagsTitleAndDescription";
import { usePrevAndNextPageNumber } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/usePrevAndNextPageNumber";
import React from "react";

export const LoggedOutSuppliersPageHelmet = () => {
  const { title, description } =
    useLoggedOutSuppliersPageMetaTagsTitleAndDescription();
  const { prev, next } = usePrevAndNextPageNumber();

  return (
    <FaireHelmet
      title={title}
      description={description ?? ""}
      prev={prev}
      next={next}
    />
  );
};
